import { css } from "@emotion/core";
import {
  color,
  fontTypes,
  fontWeight,
  fontSizes,
} from "../../constants/commons";

export const basicInformationStyle = css`
  .option-field-container {
    width: 100%;
  }
  .ant-upload.ant-upload-select-picture-card {
    border-radius: 50%;
  }

  .optional-text-style {
    font-size: ${fontSizes.xxs};
  }

  .ant-input-group.ant-input-group-compact {
    display: flex;
    align-items: center;
    justify-content: center;
    .input-field-valid ~ .floating-placeholder {
      right: 3.7em;
    }
  }

  .ant-select-selection.ant-select-selection--single {
    border-left: none;
    border-top: none;
    border-right: none;
  }

  // .ant-select {
  //   padding: 0.35em 0em 0 0;
  // }

  .result-container-style {
    width: 100%;
    .info-box {
      justify-content: flex-start;
      align-items: center;
    }
    .info-box-data {
      width: 100%;
      .title {
        flex-direction: row;
        justify-content: space-between;
      }
    }
  }

  .checkbox-label {
    color: ${color.lightishGray};
    font-family: ${fontTypes.meduim};
    font-weight: ${fontWeight.medium};
  }
  .css-1qiuhxm-RadioButtonSelect
    .ant-radio-group-solid
    .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
    border-radius: 20em;
  }

  /* Extra small devices (portrait phones, less than 576px) */
  @media (max-width: 575.98px) {
    .status-heading {
      color: ${color.black};
      font-family: ${fontTypes.bold};
      font-size: ${fontSizes.md};
      font-weight: ${fontWeight.medium};
    }
  }
  /* Small devices (landscape phones, 576px and up) */
  @media (min-width: 576px) and (max-width: 767.98px) {
    .status-heading {
      color: ${color.black};
      font-family: ${fontTypes.bold};
      font-size: ${fontSizes.md};
      font-weight: ${fontWeight.medium};
    }
  }
  /* Medium devices (tablets, 768px and up) */
  @media (min-width: 768px) and (max-width: 991.98px) {
    .status-heading {
      color: ${color.black};
      font-family: ${fontTypes.bold};
      font-size: ${fontSizes.xlg};
      font-weight: ${fontWeight.medium};
    }
  }
  /* Medium devices (tablets, 768px and up) */
  @media (min-width: 768px) and (max-width: 991.98px) {
    .status-heading {
      color: ${color.black};
      font-family: ${fontTypes.bold};
      font-size: ${fontSizes.xxlg};
      font-weight: ${fontWeight.medium};
    }
  }
  /* Extra large devices (large desktops, 1200px and up) */
  @media (min-width: 1200px) {
    .status-heading {
      color: ${color.black};
      font-family: ${fontTypes.bold};
      font-size: ${fontSizes.xxlg};
      font-weight: ${fontWeight.medium};
    }
  }
`;
